const CNY_FMT = new Intl.NumberFormat("zh-CN");

export function formatCount(num: number): string {
  if (num >= 10000) {
    return `${(num / 10000).toFixed(1)}万`;
  }
  return CNY_FMT.format(num);
}